import { v4 as uuid } from 'uuid';

import { EMPTY_OBJ } from 'Services/constants/empty';

export const SnackbarsActionTypes = {
  SNACKBAR_DELETE: 'SNACKBAR_DELETE',
  SNACKBAR_CREATE: 'SNACKBAR_CREATE',
};

const snackbarDelete = (snackbarId) => ({
  type: SnackbarsActionTypes.SNACKBAR_DELETE,
  payload: {
    snackbarId,
  },
});

const snackbarCreate = (message, options = EMPTY_OBJ) => {
  const id = uuid();
  return ({
    type: SnackbarsActionTypes.SNACKBAR_CREATE,
    payload: {
      id,
      message,
      options,
    },
  });
};

export const SnackbarsActions = {
  snackbarDelete,
  snackbarCreate,
};
